<template>
  <div class="mention-suggestion-container">
      <p>THIS IS THE SUGGESTION BOX</p>
      <div class="mention" v-for="suggestion in suggestions" :key="suggestion" @click="pickSuggestion(suggestion)">
          {{suggestion}}
      </div>
  </div>
</template>

<script>
export default {
    props: ['suggestions'],
    methods: {
        pickSuggestion(suggestion){
            this.$emit("pickSuggestion", suggestion);
        },
    },
    mounted() {
        
    }
}
</script>

<style>

</style>